// OutOfOffice.js
import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function OutOfOffice() {
  const [menuOpen, setMenuOpen] = useState(false);

  const [alternateEmail, setAlternateEmail] = useState("");
  const [isOutOfOffice, setIsOutOfOffice] = useState(false);

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorVisible, setErrorVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  // ---------------- LOAD STATUS ----------------
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const result = await apiFetch("/outofoffice/status", {
          method: "GET",
        });

        if (result.is_out_of_office) {
          setIsOutOfOffice(true);
          setAlternateEmail(result.alternate_email || "");
        } else {
          setIsOutOfOffice(false);
          setAlternateEmail("");
        }
      } catch (err) {
        console.error("Failed to load out-of-office status", err);
      }
    };

    fetchStatus();
  }, []);

  // ---------------- SUBMIT ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    const action = e.nativeEvent.submitter?.value;

    setErrorMsg("");
    setSuccessMsg("");

    if (action === "add" && !alternateEmail.trim()) {
      setErrorMsg("Alternate email is required");
      return;
    }

    try {
      let url = "/outofoffice/remove";
      let body;

      if (action === "add") {
        url = "/outofoffice/add";
        body = { alternate_email: alternateEmail };
      }

      await apiFetch(url, {
        method: "POST",
        body: body ? JSON.stringify(body) : undefined,
      });

      if (action === "add") {
        setSuccessMsg("✅ Out of office enabled");
        setIsOutOfOffice(true);
      } else {
        setSuccessMsg("✅ Back in office successfully");
        setIsOutOfOffice(false);
        setAlternateEmail("");
      }
    } catch (err) {
      setErrorMsg(err?.error || err?.message || "Something went wrong");
    }
  };

  // ---------------- AUTO-HIDE ERROR ----------------
  useEffect(() => {
    if (errorMsg) {
      setErrorVisible(true);
      const t1 = setTimeout(() => setErrorVisible(false), 4500);
      const t2 = setTimeout(() => setErrorMsg(""), 5000);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
  }, [errorMsg]);

  // ---------------- AUTO-HIDE SUCCESS ----------------
  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const t1 = setTimeout(() => setSuccessVisible(false), 4500);
      const t2 = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
  }, [successMsg]);

  return (
    <div className="add-user">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Out of Office</h2>

        <div className="messages-top" style={{ margin: "0 auto 1rem", width: "50%" }}>
          {errorMsg && (
            <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
              {errorMsg}
            </div>
          )}
          {successMsg && (
            <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          <label htmlFor="alternate-email">
            Alternate Email
            <input
              type="email"
              id="alternate-email"
              placeholder="Enter alternate email"
              value={alternateEmail}
              readOnly={isOutOfOffice}
              disabled={isOutOfOffice}
              onChange={(e) => setAlternateEmail(e.target.value)}
            />
          </label>

          <div className="action-buttons">
            <button
              type="submit"
              value="add"
              className="submit-btn"
              disabled={isOutOfOffice}
            >
              Add Alternate Email
            </button>

            <button
              type="submit"
              value="back"
              className="submit-btn"
              disabled={!isOutOfOffice}
            >
              Back in Office
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
